export function headerFunc() {
  toggleMenu();
  hederChange();
}

/**
 * ハンバーガーメニュー
 */
function toggleMenu() {
  $('.l-hamburger').on('click', function() {
    $(this).toggleClass('is-open');
    $('.l-drawer').toggleClass('is-open');
  });
  $('.l-drawer-nav__item a').on('click', function() {
    $('.l-hamburger').removeClass('is-open');
    $('.l-drawer').removeClass('is-open');
  });
}

/**
 * ヘッダースクロールで反転
 */
function hederChange() {
  $(window).on('scroll resize', function(){
    let scroll = $(window).scrollTop();
    let winH = $(window).height();
    const fvH = $('.p-home-fv').outerHeight();
    const fvTop = $('.p-home-fv').offset().top;
    const fvBottom = fvTop + fvH;
    if(scroll >= fvBottom - winH/2){
      $('.l-header--top').addClass('is-active');
      $('.js-logo-white').removeClass('is-active');
      $('.js-logo-black').addClass('is-active');
    }else{
      $('.l-header--top').removeClass('is-active');
      $('.js-logo-white').addClass('is-active');
      $('.js-logo-black').removeClass('is-active');
    }
  });
}